import { lazy } from 'react';
import useRhiVersion from '@/hooks/useRhiVersion';

const RetailHealthInsuranceHome = lazy(() => import('./index'));
const RetailHealthInsuranceHomeV1 = lazy(() => import('./v1'));

const RhiHome = () =>
  useRhiVersion() === 'v1' ? (
    <RetailHealthInsuranceHomeV1 />
  ) : (
    <RetailHealthInsuranceHome />
  );

export default RhiHome;
